import styled from 'styled-components';

export const EmptyListText = styled.p`
  text-align: center;
`;
